import PropTypes from 'prop-types';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Badge } from '@mui/material';
// routes
import { paths } from '../../../routes/paths';
// components
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  zIndex: 999,
  right: 0,
  display: 'flex',
  cursor: 'pointer',
  position: 'fixed',
  alignItems: 'center',
  top: theme.spacing(16),
  height: theme.spacing(5),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1.25),
  boxShadow: theme.customShadows.z20,
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.paper,
  borderTopLeftRadius: Number(theme.shape.borderRadius) * 2,
  borderBottomLeftRadius: Number(theme.shape.borderRadius) * 2,
  transition: theme.transitions.create('opacity'),
  '&:hover': { opacity: 0.72 },
}));

// ----------------------------------------------------------------------

CartWidget.propTypes = {
  totalItems: PropTypes.number,
};

export default function CartWidget({ totalItems }) {
  const [searchParams] = useSearchParams();

  const location_id = searchParams.get('location_id');
  const customer_id = searchParams.get('customer_id');
  return (
    <RouterLink to={`${paths.dashboard.product.checkout}?customer_id=${customer_id}&location_id=${location_id}`}>
      <StyledRoot>
        <Badge showZero badgeContent={totalItems} color="error" max={99}>
          <Iconify icon="eva:shopping-cart-fill" width={24} />
        </Badge>
      </StyledRoot>
    </RouterLink>
  );
}
